import React, { useState } from "react";
import Home from "../Home";

export default function ManageHome() {
  const [isAuth, setIsAuth] = useState(localStorage.getItem("token") || "");

  const HandleHome = () => {
    if (isAuth.length === 0) {
      return <Home />;
    } else {
      window.location.href = "/home";
    }
  };
  return (
    <>
      <HandleHome />
    </>
  );
}
